import type TagDto from "../../../../../dto/construction/TagDto";
import useApi from "../../../../../services/api/hooks/useApi";
import ApiHttpVerbs from "../../../../../services/api/types/ApiHttpVerbs";
import type ApiResponse from "../../../../../services/api/types/ApiResponse";
import Api from "../../../../../services/auth/types/IsaacApi";
import type IConstructionNewTagHook from "./IConstructionNewTagHook";

const useConstructionNewTagHook = (): IConstructionNewTagHook => {
  const {fetchData} = useApi();

  const addTagsToConstruction = async (constructionId: string, tags: TagDto[]): Promise<ApiResponse<TagDto[]>> => {
    const url = `${process.env.REACT_APP_ICC_API_URL}/constructions/${constructionId}/tags/`;
    const response = await fetchData<TagDto[]>(
      url,
      Api.ICC,
      {useGlobalHandler: false},
      ApiHttpVerbs.POST,
      {},
      JSON.stringify(tags),
    );
    return response;
  };

  const deleteTagFromConstruction = async (constructionId: string, tags: TagDto[]): Promise<ApiResponse<TagDto[]>> => {
    const url = `${process.env.REACT_APP_ICC_API_URL}/constructions/${constructionId}/tags/`;
    const response = await fetchData<TagDto[]>(
      url,
      Api.ICC,
      {useGlobalHandler: false},
      ApiHttpVerbs.DELETE,
      {},
      JSON.stringify(tags),
    );
    return response;
  };

  return {addTagsToConstruction, deleteTagFromConstruction};
};

export default useConstructionNewTagHook;
